var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61443 16.1249H11.8753C14.175 16.1249 15.9393 15.2942 15.4383 11.951L14.8547 7.42004C14.5458 5.75185 13.4817 5.1134 12.5481 5.1134H4.9142C3.96683 5.1134 2.96454 5.79991 2.60756 7.42004L2.02404 11.951C1.59841 14.9166 3.31466 16.1249 5.61443 16.1249Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 1.09091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51184 4.94886C5.51184 3.15931 6.96256 1.70859 8.7521 1.70859C9.61385 1.70493 10.4415 2.04471 11.0522 2.65278C11.6628 3.26084 12.0061 4.08711 12.0061 4.94886",
    stroke: "#666666",
    strokeWidth: 1.09091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52783 8.32635H6.56251",
    stroke: "#BFBFBF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9006 8.32635H10.9353",
    stroke: "#BFBFBF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.744af1c1903df46fe88acfd26b97d73a.svg";
export { ForwardRef as ReactComponent };